module.exports = __webpack_public_path__ + "img/icons B_38.ad5b6cc5.svg";